module.exports = {
  link: {
    model_id: null, // 所关联表单
    link_field_id: null, // 级联关联字段id
    show_field_id: null, // 显示名称id
    type: 10, // 类型：10自定义20省市区
    result_show: 10, // 选中结果显示：10完整显示20仅显示最后一级
    filter: '', // 筛选条件
    has_search: 0, // 是否带搜索：1是0否
    area_limit: 0, // 是否区域限制
    area_config: [] // 区域限制
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/cascader.js